// Validate email format
import { ValidateEmail } from "@swivl-mono/helpers";

// Extract Google Sheet ID from URL
export const extractSheetId = (url: string): string => {
  const match = url.match(/\/spreadsheets\/d\/([a-zA-Z0-9-_]+)/);
  if (!match) {
    throw new Error("Invalid Google Sheets URL format");
  }
  return match[1];
};

// Convert column index to Google Sheets column letter(s)
export const getColumnLetter = (index: number): string => {
  let colLetter = "";
  let tempIndex = index;
  while (tempIndex >= 0) {
    colLetter = String.fromCharCode((tempIndex % 26) + 65) + colLetter;
    tempIndex = Math.floor(tempIndex / 26) - 1;
  }
  return colLetter;
};

export const isValidEmail = ValidateEmail;

// Parse comma-separated emails string
export const parseEmails = (emailsString: string): string[] => {
  return emailsString
    .split(",")
    .map((e) => e.trim())
    .filter((e) => e && isValidEmail(e));
};
